
define('text!modules/reporting/segments/dataExport/templates/data-export.html',[],function () { return '<div class="segments-reports">\n    <div class="w-segments-data-export">\n        <div class="manage"></div>\n        <div class="create-edit"></div>\n    </div>\n</div>\n';});

